import { sharedCoreJa } from "./shared-core";

export const platformSupport = {
  actions: {
    cancel: "キャンセル",
    confirm: "確認",
  },
  common: {
    title: "AIRange",
    locale: "言語",
    phase: "フェーズ",
    languageChanged: "言語を {locale} に切り替えました",
  },
  shared: sharedCoreJa,
  shareMode: {
    private: "非公開",
    shared_to_users: "指定ユーザーに共有",
    public: "公開",
  },
} as const;
